import { render, staticRenderFns } from "./Approvals.vue?vue&type=template&id=481ebc82&scoped=true&"
import script from "./Approvals.vue?vue&type=script&lang=js&"
export * from "./Approvals.vue?vue&type=script&lang=js&"
import style0 from "./Approvals.vue?vue&type=style&index=0&id=481ebc82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481ebc82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('481ebc82')) {
      api.createRecord('481ebc82', component.options)
    } else {
      api.reload('481ebc82', component.options)
    }
    module.hot.accept("./Approvals.vue?vue&type=template&id=481ebc82&scoped=true&", function () {
      api.rerender('481ebc82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/verificarQrAprobaciones/vistas/Approvals.vue"
export default component.exports